// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__STH5x","buttons":"styles_buttons__127iQ"};